import { FEEDBACK } from "./constants";

const initialState = {};

export default (state = initialState, action) => {
  const { type, payload, data } = action;
  switch (type) {
    case FEEDBACK.PENDING:
      return {
        ...state,
        [payload.id]: { [type]: true }
      };
    case FEEDBACK.SUCCESS:
      return {
        ...state,
        [payload.id]: { [type]: true, data }
      };
    case FEEDBACK.ERROR:
      return {
        ...state,
        [payload.id]: { [type]: true, data }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/feedback/reducers.js